import ReactECharts from "echarts-for-react";

export default function ChartVendor({ chartData }) {
  console.log(chartData, "chartData");
  const data = chartData ?? [];

  return (
    <div
      className="dashboard-grid"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gridTemplateRows: "repeat(2, auto)",
        gap: "1.5rem",
      }}
    >
      {data.map((mo, index) => {
        const colors = [
          "#ef4444",
          "#f59e0b",
          "#22c55e",
          "#3b82f6",
          "#a855f7",
          "#ec4899",
          "#14b8a6",
        ];

        const option = {
          title: {
            text: `Jumlah Data ${mo.name.slice(0, 7) + "..."}`,
            left: "center",
          },
          tooltip: { trigger: "axis" },
          grid: { top: 50, bottom: 50, left: 60, right: 30 },
          xAxis: {
            type: "category",
            data: [mo.name],
            axisLabel: {
              interval: 0,
              formatter: function (value) {
                return value.length > 7 ? value.slice(0, 7) + "..." : value;
              },
            },
          },
          yAxis: { type: "value", min: 1, max: 5000 },
          series: [
            {
              type: "bar",
              data: [mo.vendors_filtered_count],
              itemStyle: {
                color: colors[index % colors.length],
                borderRadius: [6, 6, 0, 0],
              },
            },
          ],
        };

        return (
          <div key={mo.id} className="card shadow-sm border">
            <div className="card-body">
              <ReactECharts option={option} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
